import Vue from 'vue'
import Vuesax from 'vuesax'
import axios from 'axios'
import Embed from 'v-video-embed'
import VueCollapse from 'vue2-collapse'
import App from './App.vue'
import moment from 'moment'

import VTooltip from 'v-tooltip'

// import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'

// Vue.use(VueTreeList)
// Vue.use(Tree)
//Vue.use(TreeNode)

import {
    BootstrapVue,
    IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'vuesax/dist/vuesax.css' //Vuesax styles

// import vuetify from '@/plugins/vuetify'
// import 'vuetify/dist/vuetify.min.css'


import 'material-icons/iconfont/material-icons.css';
import 'material-symbols';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
// Datetime
import {
    Datetime
} from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueDragResize from 'vue-drag-resize'
// Vuex Store

import store from './store/store'
import VueCircleSlider from 'vue-circle-slider'
//Vue .csv
import JsonCSV from 'vue-json-csv'

// Session
import VueSessionStorage from 'vue-sessionstorage'

import VueOtp2 from 'vue-otp-2';
import OtpInput from "@bachdgvn/vue-otp-input";
// Theme Configurations
import Autocomplete from 'v-autocomplete'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-autocomplete/dist/v-autocomplete.css'
import 'prismjs'
import 'prismjs/themes/prism.css'
import VsPrism from './components/prism/VsPrism.vue';
import fullscreen from 'vue-fullscreen'
import ToggleSwitch from 'vuejs-toggle-switch'
// Vue axios
import VueSuggestion from 'vue-suggestion'
import VueZoomer from 'vue-zoomer'
import {
    VueFormBuilderPlugin
} from 'v-form-builder'
import 'v-form-builder/dist/v-form-builder.css' //load CSS from your App
import VCalendar from 'v-calendar';
import VueSignaturePad from 'vue-signature-pad';


import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import './css/VueDraggableResizable.css'
import VueHtmlToPaper from 'vue-html-to-paper';
// Vue Router
import router from './router'
import '@/assets/scss/style.scss'
import jwt from './middlewares/jwt.js'
import pic from './middlewares/pic.js'
import socket from './middlewares/socket.js'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import VueGauge from 'vue-gauge';
Vue.component('vue-gauge', VueGauge);

import VueSpeedometer from "vue-speedometer"

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import 'viewerjs/dist/viewer.css'
import Editor from 'vue-image-markup';
import VueSignature from 'vue-signature-simple'
Vue.use(VueSignature)

import ImageEditor from '@toast-ui/vue-image-editor/src/ImageEditor.vue';
import VueViewer from 'v-viewer'

//---------------------------- Icon base vue ------------------------------//
import IconBase from './assets/icon/IconBase.vue'
Vue.component('icon-base', IconBase)

//---------------------------- apexcharts vue ------------------------------//
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

//---------------------------- vue use sound ------------------------------//
import useSound from "vue-use-sound";
Vue.use(useSound)

//---------------------------- VueHorizontalList vue ------------------------------//
import VueHorizontalList from "vue-horizontal-list";
Vue.component('vue-horizontal-list', VueHorizontalList)

//---------------------------- Test VR Package------------------------------//

import VueThreeSixty from 'vue-360'
import 'vue-360/dist/css/style.css'
Vue.use(VueThreeSixty)


//---------------------------- Test VR Package------------------------------//
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
//---------------------------- DevExpress / DevExTreme -----------------------------//
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
//---------------------------- DevExpress / DevExTreme -----------------------------//

// import VideoPlayer from 'ice48623/vue-video-player'

// VideoPlayer.config({
//     youtube: true,  // default false
//     switcher: true, // default true
//     hls: true       // default true
//   })
   
  // use
// Vue.use(VideoPlayer)

Vue.use(VueViewer)
Vue.use(VTooltip)
    // Install BootstrapVue
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
    // Loading the plugin into the Vue.
Vue.use(VueCollapse)
Vue.component('v-select', vSelect)
Vue.component('datetime', Datetime);

Vue.component('vue-drag-resize', VueDragResize)

Vue.use(VueCircleSlider)
Vue.component('downloadCsv', JsonCSV)

Vue.component("v-otp-input", OtpInput);
Vue.use(VueOtp2)

Vue.use(Autocomplete)
Vue.component(VsPrism.name, VsPrism);
Vue.use(fullscreen)
Vue.use(ToggleSwitch)

Vue.use(VueSuggestion)
Vue.prototype.$http = axios
Vue.prototype.$url = "https://swdapi.ddns.net:8090/"


// Vue.prototype.$url2 = "http://52.74.95.20:8099/"
// Vue.prototype.$wss2 = "http://52.74.95.20:4000/"

Vue.prototype.$url2 = "https://api.sentenance.com:8094/"
Vue.prototype.$wss2 = "https://api.sentenance.com:4000/"

// Vue.prototype.$url2 = "http://192.168.10.90:8090/"

Vue.prototype.$url3 = "http://3.1.189.234:8094/"
    // Vue.prototype.$url = "http://localhost:8090/"
Vue.prototype.$API = new jwt.API()
Vue.prototype.$jwt = jwt
Vue.prototype.$PIC = new pic.PIC()
Vue.prototype.$WSS = new socket.WSS()
    // Vue.prototype.$socket = socket.socket
    // Vue.prototype.$MC = getMAC()
Vue.config.silent = true

// Vue.prototype.$hideSideBar = this.$store.commit("IS_SIDEBAR_ACTIVE", false);

// momentjs
Vue.prototype.$moment = moment
import vGoogleTranslate from 'v-google-translate';
Vue.use(vGoogleTranslate)
Vue.use(VueZoomer)
    // Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
        componentPrefix: 'vc'
    }) // Use <vc-calendar /> instead of <v-calendar />

// install now
Vue.use(VueFormBuilderPlugin)

// Signature Pad

Vue.use(VueSignaturePad)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(Vuesax, {
    theme: {
        colors: {
            primary: '#32c040',
            secondary: '#4e4e4e',
            warning: '#ff911e',
            info: 'rgb(0, 123, 255)',
            third: '#00661b',
        }
    }
})
const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
        'https://unpkg.com/kidlat-css/css/kidlat.css'
    ]
}

Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
Vue.use(Embed);

// window.BeforeUnloadEvent(() => {
//     Vue.prototype.$http.post(Vue.prototype.$url+'logout', {
//         username: Vue.prototype.$session.get('username')
//     })
// })
// Vue Session
Vue.use(VueSessionStorage)

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')